import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveTool } from '../../../../redux/toolsSlice';

// Walkthrough Editor v2 — Add Interactive Element library (BL-141).
// Replaces the old inline tool palette. Grouped + searchable; picking an
// element sets the active tool (dispatch setActiveTool), then the learner
// clicks the screenshot to place it — the same placement flow the legacy
// palette used, so behaviour is unchanged.

const HotspotI = () => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3l7 18 2.5-7L20 11 3 3z" /></svg>);
const InputI = () => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="7" width="18" height="10" rx="2" /><path d="M7 12h.01M11 12h6" /></svg>);
const SelectI = () => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M8 10l4 4 4-4" /></svg>);
const TextI = () => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 6h16M12 6v14M8 20h8" /></svg>);
const ArrowI = () => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M7 17L17 7M9 7h8v8" /></svg>);
const SquareI = () => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2" /></svg>);

const GROUPS = [
  {
    group: 'Interactive',
    items: [
      { tool: 'hotspot', name: 'Hotspot', desc: 'A clickable target that advances the step.', icon: <HotspotI /> },
      { tool: 'textInput', name: 'Text input', desc: 'Capture what the learner types.', icon: <InputI /> },
      { tool: 'dropdown', name: 'Dropdown', desc: 'A select the learner opens and picks from.', icon: <SelectI /> }
    ]
  },
  {
    group: 'Guidance',
    items: [
      { tool: 'text', name: 'Text / callout', desc: 'Add a note or label on the screen.', icon: <TextI /> },
      { tool: 'line', name: 'Arrow / line', desc: 'Point to something specific.', icon: <ArrowI /> },
      { tool: 'square', name: 'Box / highlight', desc: 'Frame or emphasize an area.', icon: <SquareI /> }
    ]
  }
];

const WalkthroughAddElementModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const [q, setQ] = useState('');
  if (!open) return null;

  const norm = q.trim().toLowerCase();
  const pick = (tool) => {
    dispatch(setActiveTool(tool));
    onClose();
  };

  return (
    <div
      className="un-we-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="un-we-amodal" role="dialog" aria-label="Add Interactive Element">
        <div className="un-we-amodal__h">
          <span className="t">Add Interactive Element</span>
          <button type="button" className="x" aria-label="Close" onClick={onClose}>×</button>
        </div>
        <div className="un-we-amodal__search">
          <input
            type="text"
            placeholder="Search elements…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            autoFocus
          />
        </div>
        <div className="un-we-amodal__scroll">
          {GROUPS.map((g) => {
            const items = g.items.filter(
              (it) => !norm || it.name.toLowerCase().includes(norm) || it.desc.toLowerCase().includes(norm)
            );
            if (items.length === 0) return null;
            return (
              <div key={g.group}>
                <div className="un-we-amodal__grp">{g.group}</div>
                {items.map((it) => (
                  <button type="button" key={it.tool} className="un-we-arow" onClick={() => pick(it.tool)}>
                    <span className="un-we-arow__ic">{it.icon}</span>
                    <span className="un-we-arow__txt">
                      <span className="t">{it.name}</span>
                      <span className="d">{it.desc}</span>
                    </span>
                  </button>
                ))}
              </div>
            );
          })}
        </div>
        <div className="un-we-amodal__foot">Pick an element, then click on the screenshot to place it.</div>
      </div>
    </div>
  );
};

export default WalkthroughAddElementModal;
